// extracted by mini-css-extract-plugin
export default {"root":"ReportsConfigurationHeader_root__-7K+l","search-btn":"ReportsConfigurationHeader_search-btn__193Gz"};